<template>
    <div id="appCapsule">
        <div class="section mt-2">
            <!-- card block -->
            <div
                style="margin: 5px 0"
                class="choose-acc-card"
                v-for="account in accounts"
                :key="account.id"
            >
                <div class="choose-acc-card-inner">
                    <ul class="choose-acc-card-ul">
                        <li
                            class="choose-acc-card-li csli-acc-btn showing-account"
                        >
                            <div class="cs-acc-card-li-desc">
                                <div class="cs-acc-type">
                                    <div class="cs-acc-type-icon">
                                        <svg
                                            version="1.0"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="40"
                                            height="40"
                                            viewBox="0 0 512.000000 512.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <g
                                                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                                fill="#000000"
                                                stroke="none"
                                            >
                                                <path
                                                    d="M2166 5059 c-386 -56 -713 -334 -829 -704 -90 -288 -43 -619 124 -866 54 -80 166 -199 243 -255 34 -26 53 -46 45 -48 -8 -3 -39 -12 -69 -21 -89 -28 -119 -71 -89 -126 19 -37 51 -40 143 -13 372 108 763 109 1124 5 57 -16 111 -27 120 -24 35 13 52 36 52 74 0 46 -20 63 -100 85 -30 8 -61 17 -69 20 -10 3 -1 13 25 31 73 49 162 133 215 203 59 78 55 77 160 49 l35 -9 -14 -77 c-8 -50 -12 -120 -9 -193 7 -190 62 -318 185 -432 110 -101 247 -152 412 -151 140 1 217 28 290 101 37 38 66 80 85 124 17 37 33 68 37 68 14 0 117 -155 157 -235 22 -44 51 -110 64 -148 29 -81 59 -126 102 -156 18 -12 93 -42 167 -67 102 -34 142 -52 164 -75 l29 -30 0 -229 0 -229 -30 -31 c-24 -25 -64 -42 -228 -95 -120 -39 -213 -75 -233 -90 -18 -14 -63 -70 -98 -124 -114 -173 -276 -326 -464 -438 -131 -78 -162 -101 -172 -127 -5 -14 -34 -156 -64 -316 -30 -160 -58 -295 -61 -300 -4 -6 -85 -10 -201 -10 -192 0 -195 0 -204 23 -5 12 -23 94 -40 182 -42 227 -60 245 -214 226 -187 -24 -405 -31 -603 -20 -262 16 -257 20 -303 -226 -17 -87 -35 -164 -41 -172 -16 -18 -382 -19 -396 -1 -6 7 -34 137 -63 288 -29 151 -59 288 -67 303 -8 16 -28 36 -45 45 -256 141 -470 355 -587 590 -45 89 -97 250 -117 362 -22 117 -25 418 -5 530 69 401 253 689 579 903 98 64 113 86 96 136 -5 14 -23 32 -39 40 -27 13 -33 12 -80 -13 -148 -82 -323 -236 -428 -377 -139 -186 -217 -371 -273 -646 -8 -39 -21 -25 -27 28 -22 182 -186 327 -326 289 -86 -23 -171 -132 -171 -219 0 -104 98 -191 263 -232 l49 -12 -49 -49 c-60 -62 -125 -95 -216 -113 -103 -20 -134 -67 -85 -130 20 -26 24 -27 98 -23 64 2 88 9 153 41 85 42 196 143 232 210 13 24 27 37 40 37 19 0 20 -5 17 -73 -5 -89 13 -292 34 -396 37 -180 116 -370 222 -531 100 -151 310 -343 493 -451 l44 -26 48 -254 c27 -140 55 -273 63 -296 18 -50 69 -98 121 -113 25 -8 112 -10 248 -8 199 3 212 4 247 26 57 35 74 73 106 237 l29 150 44 -1 c292 -9 574 -1 729 19 11 2 19 -22 32 -93 38 -203 49 -240 79 -275 53 -60 87 -67 330 -63 l216 3 42 28 c28 18 49 43 61 70 10 23 42 168 71 323 l53 281 50 28 c240 133 460 338 598 556 40 63 28 57 268 134 221 71 268 104 310 213 18 47 20 76 20 272 0 196 -2 225 -20 272 -39 101 -93 142 -265 198 -74 24 -139 51 -151 64 -12 11 -38 64 -57 116 -57 148 -134 273 -267 432 l-30 36 16 89 c21 113 30 398 15 478 -16 86 -58 165 -101 190 -93 53 -325 1 -694 -156 -77 -33 -151 -67 -162 -74 -16 -10 -31 -12 -55 -5 -19 5 -53 14 -75 19 l-42 11 25 62 c31 76 63 225 63 296 0 63 -23 92 -73 92 -50 0 -68 -26 -77 -113 -34 -300 -210 -556 -473 -688 l-77 -39 -160 12 c-124 9 -193 9 -310 -1 -151 -12 -151 -12 -204 12 -229 105 -406 314 -478 562 -19 68 -23 102 -22 230 1 133 4 160 27 238 46 150 115 265 224 374 395 396 1066 311 1353 -170 58 -98 93 -116 144 -76 41 32 35 71 -26 169 -100 163 -284 322 -461 396 -171 72 -366 98 -541 73z m2036 -1386 c9 -27 13 -94 12 -228 0 -156 -4 -208 -22 -293 -28 -130 -75 -260 -113 -312 -55 -75 -173 -105 -305 -77 -178 38 -295 146 -339 312 -29 113 -12 338 29 384 19 21 221 112 372 167 123 45 267 83 316 84 33 0 38 -3 50 -37z m-3876 -1143 c33 -21 84 -107 84 -141 0 -17 -3 -17 -64 0 -80 22 -130 51 -134 78 -4 24 43 83 65 83 9 0 30 -9 49 -20z"
                                                ></path>
                                                <path
                                                    d="M2312 4578 c-7 -7 -12 -22 -12 -34 0 -17 -8 -23 -37 -29 -104 -18 -183 -88 -204 -179 -28 -128 34 -233 172 -288 l64 -26 3 -156 3 -157 -28 7 c-48 12 -87 30 -127 63 -46 37 -79 40 -100 9 -54 -76 50 -179 199 -197 45 -5 50 -9 53 -34 7 -58 82 -56 82 2 0 25 5 30 43 39 141 36 219 171 188 324 -7 30 -23 70 -36 88 -31 42 -102 92 -154 110 l-41 13 0 134 c0 152 -2 149 90 113 28 -11 59 -20 69 -20 29 0 53 34 49 71 -2 28 -10 38 -46 57 -25 14 -67 26 -102 29 -53 5 -60 8 -60 27 0 26 -18 46 -40 46 -9 0 -21 -5 -28 -12z m-2 -298 l0 -120 -50 25 c-56 28 -72 52 -74 106 -1 42 22 74 69 95 55 24 55 24 55 -106z m109 -314 c53 -34 79 -99 62 -156 -12 -42 -61 -90 -92 -90 -18 0 -19 8 -19 135 0 74 2 135 5 135 3 0 23 -11 44 -24z"
                                                ></path>
                                                <path
                                                    d="M3830 2383 c-53 -68 23 -222 132 -267 51 -22 143 -20 193 3 109 49 179 196 125 264 -42 53 -130 21 -130 -49 0 -12 -12 -36 -26 -53 -21 -26 -33 -31 -69 -31 -36 0 -48 5 -69 31 -15 18 -26 43 -26 60 0 67 -88 95 -130 42z"
                                                ></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <div
                                        class="cs-acc-type-desc"
                                        v-if="account.isActive == 1"
                                    >
                                        {{ account.type }} ****
                                        {{ account.number.slice(-4) }}
                                    </div>
                                </div>
                                <div class="cs-acc-card-li-action">
                                    <ion-icon
                                        name="ellipsis-horizontal-outline"
                                        role="img"
                                        class="md hydrated"
                                        aria-label="ellipsis horizontal outline"
                                    ></ion-icon>
                                </div>
                            </div>
                            <div
                                class="text-white"
                                v-if="account.isActive == 0"
                                style="margin: 10px 0"
                            >
                                Generating {{ account.type }} ({{
                                    account.currency.code
                                }}) Account...
                            </div>

                            <div
                                class="cs-acc-bals-dyno"
                                v-if="account.isActive == 1"
                            >
                                <div class="cs-acc-bals-label">Current</div>
                                <div class="cs-acc-bals-txt">
                                    {{ account.currency.symbol
                                    }}{{
                                        parseFloat(account.balance).toFixed(2)
                                    }}
                                </div>
                            </div>
                            <div
                                class="cs-acc-bals-dyno"
                                v-if="account.isActive == 1"
                            >
                                <div class="cs-acc-bals-label">
                                    Available
                                </div>
                                <div class="cs-acc-bals-txt">
                                    {{ account.currency.symbol
                                    }}{{
                                        parseFloat(account.balance).toFixed(2)
                                    }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- * card block -->
        </div>

        <div class="absolute-btn-container">
            <a
                href="javascript:void(0)"
                class="button"
                @click.prevent="viewCard"
            >
                <button class="x-add-acc-btn">
                    <ion-icon name="add-outline"></ion-icon>
                </button>
            </a>
            <a
                href="javascript:void(0)"
                class="button"
                id="goBackCard"
                style="display: none;"
            >
                <button class="x-add-acc-btn">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </button>
            </a>
        </div>

        <div
            style="margin-top: 70px"
            class="modal fade"
            id="modal-account"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Account Request</h5>
                        <button type="button" class="cls-mdl-btn x-closeModal">
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill="#812655"
                                    d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <form action="" method="POST">
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label"
                                            >Account Type</label
                                        >
                                        <div class="i-option-select">
                                            <select
                                                v-model="accountType"
                                                class="form-control custom-select select2-no-search"
                                                style="width: 100%; height: 50px"
                                            >
                                                <option value="SAVINGS"
                                                    >Savings Account</option
                                                >
                                                <option value="JOIN"
                                                    >Joint Account</option
                                                >
                                                <option value="CHECKING"
                                                    >Checking Account</option
                                                >
                                                <option value="OFFSHORE"
                                                    >OffShore Account</option
                                                >
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label">Currency</label>
                                        <div class="i-option-select">
                                            <select
                                                v-model="accountCurrency"
                                                name="account_currency"
                                                class="form-control custom-select select2-no-search"
                                                style="width: 100%; height: 50px"
                                                required
                                            >
                                                <option value="1"
                                                    >Euro (€)</option
                                                >
                                                <option value="2"
                                                    >Pounds (£)</option
                                                >
                                                <option value="3"
                                                    >Australian dollar
                                                    ($)</option
                                                >
                                                <option value="4"
                                                    >New Zealand dollar
                                                    ($)</option
                                                >
                                                <option value="5"
                                                    >Canadian dollar ($)</option
                                                >
                                                <option value="6"
                                                    >Japanese yen (¥)</option
                                                >
                                                <option value="7"
                                                    >Swiss franc (₣)</option
                                                >
                                                <option value="8"
                                                    >United States Dollar
                                                    ($)</option
                                                >
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <button
                                        @click.prevent="requestAccount"
                                        :disabled="processing"
                                        type="submit"
                                        name="add_account"
                                        class="btn btn-primary btn-block btn-lg link-loader"
                                    >
                                        {{
                                            processing
                                                ? "Processing..."
                                                : "Request Account"
                                        }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
    data() {
        return {
            processing: false,
            accounts: [],
            accountType: "SAVINGS",
            accountCurrency: "1"
        };
    },
    methods: {
        viewCard() {
            $("#modal-account").modal("show");
        },

        async requestAccount() {
            this.processing = true;
            const aData = {
                currency: this.accountCurrency,
                account_type: this.accountType
            };
            try {
                await AR.userAccountRequest(aData);
                $("#modal-card").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Account request successful"
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } catch (error) {
                this.processing = false;

                toast.fire({
                    type: "error",
                    title: error.response.data.message
                });
            }
        }
    },
    created() {
        AR.loggedInUser().then(response => {
            this.accounts = response.data.accounts;
        });
    }
};
</script>
